// Run before Qikify's deferred app script, after its inline settings are parsed.
// Keep the clicked Globo preorder button when resuming the charity-card popup.
window.QikifyBoosterKit = {
  ...window.QikifyBoosterKit,
  listenerCheckRerenderAtc: true,
  // Globo may render before Qikify. Bind the active button in either load order.
  atcSubmitSelector: '[type="submit"]:not(.gPreorderHidden)'
};
